import * as yup from 'yup';

yup.addMethod(yup.boolean, 'checked', function () {
  return this.test({
    name: 'is-true-value',
    message: 'components.form.validation.boolean.checked',
    test: (value) => value === true,
  });
});
